import React, { useCallback, useMemo } from "react";
import PhoneInput from "react-phone-number-input";
// @ts-expect-error - CSS import has no TypeScript declaration file
import "react-phone-number-input/style.css";
// @ts-expect-error - CSS import has no TypeScript declaration file
import "./PhoneInput.css";
import { Input } from "../Input";

interface PhoneInputProps {
  value?: string;
  onChange?: (value: string | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  className?: string;
  label?: React.ReactNode;
}

const PhoneInputComponent = React.memo(function PhoneInputComponent({
  value,
  onChange,
  placeholder,
  disabled,
  error,
  className,
  label,
  ...props
}: PhoneInputProps) {
  const handleChange = useCallback(
    (newValue: string | undefined) => {
      onChange?.(newValue || undefined);
    },
    [onChange],
  );

  const InputComponent = useMemo(() => {
    const InputComp = (inputProps: React.ComponentProps<typeof Input>) => (
      <Input {...inputProps} error={error} className="w-full" />
    );
    InputComp.displayName = "PhoneInputComponent";
    return InputComp;
  }, [error]);

  const phoneInputClassName = useMemo(() => {
    return `phone-input ${error ? "border-red-500" : "border-border"} ${
      disabled ? "opacity-50 cursor-not-allowed" : ""
    }`;
  }, [error, disabled]);

  return (
    <div className="w-full">
      {label && (
        <label className="text-foreground mb-2 block text-sm font-normal">
          {label}
        </label>
      )}
      <div className={`phone-input-container h-8 ${className || ""}`}>
        <PhoneInput
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled}
          defaultCountry="US"
          international
          countryCallingCodeEditable={false}
          className={phoneInputClassName}
          inputComponent={InputComponent}
          addInternationalOption={false}
          {...props}
        />
      </div>
      {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </div>
  );
});

export { PhoneInputComponent as PhoneInput };
export { PhoneInputSimple } from "./PhoneInputSimple";
